import { render, staticRenderFns } from "./CreatePurchaseReturn.vue?vue&type=template&id=512f7b28"
import script from "./CreatePurchaseReturn.vue?vue&type=script&lang=js"
export * from "./CreatePurchaseReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports